import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { BASE_URL, CALENDAR_URL, POD_URL } from "../../Routes/urls";
import { SelectedService } from "../../ts/models/Event";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import Modal from "../../components/Modal/Modal";
import classes from "./ServicesWarning.module.css";

type Props = {
  message: string;
  unavailableServices: SelectedService[];
  onClose: (proceed: boolean) => void;
};

const ServicesWarning: React.FC<Props> = ({
  message,
  unavailableServices,
  onClose,
}) => {
  const { pod, resourceName } = useSelector((state: RootState) => state.pod);
  const servicesMaster = useSelector(
    (state: RootState) => state.masters.services
  );
  const podId = pod.id;
  const navigate = useNavigate();
  const returnToCalendarHandler = () => {
    navigate(
      `${BASE_URL}/${resourceName}/${POD_URL}/${podId}/${CALENDAR_URL}${window.location.search}`
    );
  };

  const serviceNames = unavailableServices.map((serviceWithId) => {
    const service = servicesMaster.find(
      (service) => service.id === serviceWithId.serviceId
    );

    if (service) {
      return service.name;
    } else {
      return "";
    }
  });

  return (
    <Modal className={classes.main}>
      <>
        <div className={classes.messageContainer}>
          <div>{message}</div>
          {serviceNames.length > 0 && (
            <>
              <div className={classes.serviceNamesContainer}>
                <div className={classes.serviceName}>
                  {serviceNames?.map((serviceName, idx) => (
                    <div key={idx}>{serviceName}</div>
                  ))}
                </div>
              </div>
              <div>
                You can proceed with your order for the remaining services or
                return to the event calendar and pick another date.
              </div>
            </>
          )}
        </div>
        <div className={classes.actionContainer}>
          {serviceNames.length > 0 && (
            <PrimaryButton
              className={classes.action}
              name='Proceed with order'
              onClick={() => onClose(true)}
            />
          )}
          <PrimaryButton
            className={classes.action}
            name='Return to Calendar'
            onClick={returnToCalendarHandler}
          />
        </div>
      </>
    </Modal>
  );
};

export default ServicesWarning;
